import { ApiObjectService } from './api-object.service'

class DictionaryColorsService extends ApiObjectService {
    namespace = 'dictionary-colors'
}

export const dictionaryColorsService = new DictionaryColorsService()
